/**
 * Bridge between the client-side annotation image upload (localStorage-backed
 * stopgap) and any surface that wants to show a per-ticket thumbnail.
 *
 * Cards normally render `ticket.thumbnailUrl` from the server. Until the
 * attachments/capture endpoint fully persists uploaded images server-side
 * (see upnext.md), uploads made in the annotation canvas only live in
 * `vd-annot-imgs-<ticketId>`. Card callers use `readLocalThumb(id)` as a
 * fallback so a user's upload at least shows up in their own browser.
 *
 * This is cross-browser broken by design — localStorage is per-origin per-
 * browser. When the attachments endpoint lands, delete this helper and
 * point cards at the real server-provided URL.
 */
export function readLocalThumb(ticketId: string): string | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const raw = window.localStorage.getItem(`vd-annot-imgs-${ticketId}`);
    if (!raw) return undefined;
    const imgs = JSON.parse(raw) as Array<{ url?: string }>;
    return imgs[0]?.url;
  } catch {
    return undefined;
  }
}
